(function () {
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    var grid = document.getElementById('product-grid-ajax');
    if (!grid) return;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (swat.advancedCollectionsApi) swat.advancedCollectionsApi.reinitialize();
      }, 100);
    }).observe(grid, { childList: true });
  });
})();
